import React, { useState } from 'react';
import '../../styles/home.css';

// Cupom de boas-vindas (ticket dourado, marcação exata) + estado "aplicada ✓"
export const CupomTicket: React.FC = () => {
  const [applied, setApplied] = useState(false);

  return (
    <div className="cupom" role="status" aria-live="polite">
      <div className="ticket">STELA10</div>
      <div>
        <b>Você ganhou um cupom de boas-vindas</b>
        <span className="txt">10% no primeiro pacote de créditos — válido por 7 dias após criar seu mapa.</span>
      </div>
      <button
        onClick={() => {
          setApplied(true);
          document.getElementById('pacotes')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }}
        className="btn gold"
      >
        {applied ? 'Aplicada ✓' : 'Aplicar e ver pacotes'}
      </button>
    </div>
  );
};